import createSagaMiddleware from 'redux-saga';
import { lendingAPISagaWorkers } from '@api/lendingAPI/LendingAPI.sagas';
import { intercomSagaWorkers } from '../iwIntercom/IwIntercom.sagas';
import { errorSagaWorkers } from '../iwLogger/IwLogger.sagas';
import { routerSagaWorkers } from '../iwRouter/IwRouter.sagas';
import { siteContextSagaWorkers } from '../iwSiteContext/IwSiteContext.sagas';
import { threatmetrixSagasWorkers } from '../iwThreatmetrix/iwThreatmetrix.sagas';
import { myAccountSagaWorkers } from '../myAccount/MyAccount.sagas';
import { trackingSagaWorkers } from '../tracking/tracking.sagas';

export const sagaMiddleware = createSagaMiddleware();

export function startSagasWorkers() {
    sagaMiddleware.run(mainSagaWorker);
}

function* mainSagaWorker() {
    yield [
        ...errorSagaWorkers,
        ...trackingSagaWorkers,
        ...threatmetrixSagasWorkers,
        ...intercomSagaWorkers,
        ...siteContextSagaWorkers,
        ...routerSagaWorkers,
        ...lendingAPISagaWorkers,
        ...myAccountSagaWorkers
    ];
}
